import React, { useContext } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import Chip from "../../../../components/basics/Chip";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";

import { PrescricaoContext } from "../contexts/PrescricaoContext";
import usePrescricaoController from "../controllers/PrescricaoController";
import { HeaderAccordion } from "../styles/Prescricao";

// falta tudo, selecioanar um produto Aro que irá compor a Prescricao
// trara o valor cadastrado mas poderá ser alterado na prescrição

const AccordionPrescricaoCadastroAro = ({ ...props }) => {
  const { handleChangeOpenAcordion } = usePrescricaoController();
  const {
    expanded,
    aroCor,
    setAroCor,
    aroTamanho,
    setAroTamanho,
    aroAjuste,
    setAroAjuste,
    aroHaste,
    setAroHaste,
    aroFrente,
    setAroFrente,
  } = useContext(PrescricaoContext);

  const listOptions = [
    {
      label: "SIM",
      id: "S",
    },
    {
      label: "NÃO",
      id: "N",
    },
  ];
  const listAjuste = [
    {
      label: "Manter Ajuste",
      id: "M",
    },
    {
      label: "Ajustar Ponteira",
      id: "P",
    },
    {
      label: "Ajustar + Ponteira",
      id: "MP",
    },
  ];

  return (
    <>
      <Grid item xs={12}>
        <Accordion expanded={expanded.registerFrame || false}>
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon
                onClick={() => handleChangeOpenAcordion("registerFrame")}
              />
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container spacing={1} alignItems="center">
                <Grid
                  item
                  xs
                  onClick={() => handleChangeOpenAcordion("registerFrame")}
                >
                  <Chip label="ARO" bgcolor={"default"} />
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item lg={4} md={3} sm={6} xs={4}>
                <TextFieldErp
                  label="Cor"
                  value={aroCor}
                  setValue={setAroCor}
                ></TextFieldErp>
              </Grid>
              <Grid item lg={4} md={3} sm={6} xs={4}>
                <TextFieldErp
                  label="Tamanho"
                  value={aroTamanho}
                  setValue={setAroTamanho}
                  decimals={0}
                  type="number"
                  InputProps={{ min: 0, max: 10 }}
                ></TextFieldErp>
              </Grid>
              <Grid item lg={4}></Grid>
              <Grid item lg={4} md={3} sm={6} xs={4}>
                <SelectErp
                  id="ajuste"
                  label="Ajuste"
                  descriptionField="label"
                  optionsList={listAjuste}
                  value={aroAjuste}
                  setValue={setAroAjuste}
                />
              </Grid>
              <Grid item lg={4} md={3} sm={6} xs={4}>
                <SelectErp
                  id="tirarHaste"
                  label="Tirar Tensão da Haste"
                  descriptionField="label"
                  optionsList={listOptions}
                  value={aroHaste}
                  setValue={setAroHaste}
                />
              </Grid>
              <Grid item lg={4} md={3} sm={6} xs={4}>
                <SelectErp
                  id="abrirFrente"
                  label="Abrir Frente"
                  descriptionField="label"
                  optionsList={listOptions}
                  value={aroFrente}
                  setValue={setAroFrente}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
};

export { AccordionPrescricaoCadastroAro };
